module.exports = __webpack_public_path__ + "static/forecast/weather/nightmodrain-222e23a299a87a587c2718b70df39ec5.svg";